<template>
    <div class="box-loader" :class="{ 'screen-page': isLoadingPage }">
        <span
            :class="[isLoadingWhiteColor ? 'white__loader' : 'loader']"
        ></span>
    </div>
</template>
<script>
export default {
    props: {
        isLoadingPage: {
            type: Boolean,
            default: true,
        },
        isLoadingWhiteColor: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss">
@import "@/public/scss/common/loading.scss";
</style>
